import { Link } from 'react-router-dom';
import { JobListItem } from './JobListItem';
import type { UpcomingJob } from '@/lib/api/dashboard';

export const UpcomingJobs = ({ jobs }: { jobs: UpcomingJob[] }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold leading-tight tracking-[-0.015em] text-gray-900">
          Upcoming &amp; Active Jobs
        </h2>
        <Link to="/jobs" className="text-sm font-bold text-primary hover:underline">View all</Link>
      </div>
      <div className="flex flex-col rounded-xl bg-white border border-gray-200 overflow-hidden">
        {jobs.length === 0 ? (
          <div className="flex flex-col items-center gap-2 p-10 text-center">
            <span className="material-symbols-outlined text-3xl text-gray-300">work_off</span>
            <p className="text-sm text-gray-500">No active or upcoming jobs</p>
            <Link to="/jobs/new" className="text-sm font-bold text-primary hover:underline">Create a job</Link>
          </div>
        ) : (
          jobs.map((job) => <JobListItem key={job.id} job={job} />)
        )}
      </div>
    </div>
  );
};
